import React, { useState, useEffect } from "react";
import { Maximize, UploadCloud, Expand } from "lucide-react";
import DocumentPreview from "../../Create-Investment/documentpreview";
import { useDispatch, useSelector } from "react-redux";
import { clearCurrentStep } from "../../../Redux/store/onboardingFormSlice";
import LabelValue from "../../../Components/onboarding/label-value-review";
import FilePreview from "../../../Components/onboarding/file-preview";
import TrusteesPanel from "../../../Components/onboarding/trustee-panel";
import { useToast } from "../../../Utils/toastContext";
import { clearApplicationTypeShareHolder } from "../../../Redux/store/accountTypeSlice";
import {
  setStepStatusShareholder,
  setRejectedFieldsShareholder,
  clearStepStatusShareholder,
  clearCurrentStepShareholder,
} from "../../../Redux/store/onboardingFormSlice";
import { useNavigate, useLocation, useParams } from "react-router-dom";

const ReviewSubmitTrust = ({ setCurrentStep }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { shareholderId, userType } = useParams();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const formData = useSelector((state) => state.form.formData);
  const [firstName, setFirstName] = useState("John");
  const [companycategoryId, setCompanycategoryId] = useState(3);
  const [countryId, setCountryId] = useState(4);
  const [countryType, setCountryType] = useState(14);
  const [lastName, setLastName] = useState("Mayer");
  const [email, setEmail] = useState("mayer@gmail.com");
  const [otherActivity, setOtherActivity] = useState("");
  const [mobileNumber, setMobileNumber] = useState("+61 6 7898 7298");
  const [customerType, setCustomerType] = useState("+61 6 7898 7298");
  const [refNumber, setRefNumber] = useState(new Array(7).fill(""));
  const [fullSettlorName, setFullSettlorName] = useState("");
  const [trustType, setTrustType] = useState("Bare");
  const [finServicesLicense, setFinServicesLicense] = useState("");
  const [purpose, setPurpose] = useState("");
  const [registrationNumber, setRegistrationNumber] = useState("");
  const [fileAbn, setFileAbn] = useState(null);
  const [assets, setAssets] = useState([]);
  const stepStatus = useSelector((state) => state.form.stepStatus);
  const [typeOfAccount, setTypeOfAccount] = useState(
    "Customer with joint account between a husband and wife with same address",
  );
  const [fullName, setFullName] = useState("John Mayer");
  const [formerNames, setFormerNames] = useState("John Mayer");
  const [dob, setDob] = useState("4/5/1988");
  const [redAddress, setRedAddress] = useState(
    "122NC Cross Road, Main City Melbourne",
  );
  const [ownership, setOwnership] = useState("");
  const [toCurrencyText, setToCurrencyText] = useState("");
  const [source, setSource] = useState("");
  const [investmentAmountText, setInvestmentAmountText] = useState("");
  const [agentName, setAgentName] = useState("");
  const [agentAddress, setAgentAddress] = useState("");

  const [applicantCountryText, setApplicantCountryText] = useState("Australia");
  const [clientNo, setClientNo] = useState("CM0013189P");
  const [jointAccountID, setJointAccountID] = useState("CM0013189P");
  const [expectedAmount, setExpectedAmount] = useState("$50 - $100 million");
  const [investmentCurrency, setInvestmentCurrency] = useState("AUD");
  const [signatory, setSignatory] = useState("yes");
  const [thirdPartySign, setThirdPartySign] = useState("yes");
  const [jointAccountName, setJointAccountName] = useState("");
  const [fileAttorney, setFileAttorney] = useState(null);
  const [taxResidentCountry, setTaxResidentCountry] = useState(1);
  const [taxResidentCountryText, setTaxResidentCountryText] = useState("US");
  const [businessNature, setBusinessNature] = useState(null);
  const [businessNatureText, setBusinessNatureText] = useState("");
  const [nonResCountry, setNonResCountry] = useState(null);
  const [nonResCountryText, setNonResCountryText] = useState("");
  const [socialSecurityNumber, setSocialSecurityNumber] = useState("");
  const [taxId, setTaxId] = useState("");
  const [abn, setAbn] = useState("");
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState("ACB2231");
  const [businessAddress, setBusinessAddress] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [activity, setActivity] = useState("smaple text");
  const [businessActivityText, setBusinessActivityText] =
    useState("smaple text");
  const [fundSource, setFundSource] = useState("smaple text");
  const [transactionNature, setTransactionNature] = useState("");
  const [caprockFund, setCaprockFund] = useState("smaple text");
  const [image, setImage] = useState("/avatar.svg");
  const [fullscreen, setFullscreen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmSubmit, setIsConfirmSubmit] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [fileThirdParty, setFileThirdParty] = useState(null);
  const [description, setDescription] = useState("testing 1 2 3");
  const [fileProof, setFileProof] = useState(null);
  const [jointAccountMembers, setJointAccountMembers] = useState([]);
  const [applicantCountry, setApplicantCountry] = useState(null);
  const [accountType, setAccountType] = useState({
    value: 1,
    label: "Regulated Trust",
  });
  const [accountTypeLabel, setAccountTypeLabel] = useState("Individual");
  const [companyTypeId, setCompanyTypeId] = useState(1);
  const [advisorName, setAdvisorName] = useState("Brian	Vaughan");
  const [preview, setPreview] = useState("/avatar.svg");
  const [stateId, setStateId] = useState(null);
  const [stateText, setStateText] = useState("");
  const [stockExchangeId, setStockExchangeId] = useState("");
  const [transactionLevel, setTransactionLevel] = useState("");
  const [toCurrency, setToCurrency] = useState(2);
  const [investmentAmount, setInvestmentAmount] = useState(null);

  const secondheaders = [
    "",
    "First Name",
    "Last Name",
    "Email Address",
    "Mobile Number",
    "Account Type",
  ];
  const secondheadersWithAddress = [
    "",
    "First Name",
    "Last Name",
    "Email Address",
    "Mobile Number",
    "Residential Address",
    "Account Type",
  ];
  const [companyCategory, setCompanyCategory] = useState("");
  const [DoI, setDoI] = useState("");
  const [foreignRegistered, setForeignRegistered] = useState("");
  const [companyRegistrationNumber, setCompanyRegistrationNumber] =
    useState("");
  const [fileAccountantCertificate, setFileAccountantCertificate] =
    useState(null);
  const [foreignAddress, setForeignAddress] = useState("");
  const [stateName, setStateName] = useState("");
  const [EIN, setEIN] = useState("");
  const [acn, setAcn] = useState("");
  const [stockRegistered, setStockRegistered] = useState("");
  const [arbn, setArbn] = useState("");
  const [companySecretary, setCompanySecretary] = useState("");
  const [companyTypeText, setCompanyTypeText] = useState("");
  const [companyCodeText, setCompanyCodeText] = useState("");
  const [countryCode, setCountryCode] = useState(1);
  const [countryCodeText, setCountryCodeText] = useState("Australia");
  const [isDataAvailable, setIsDataAvailable] = useState(false);

  const [registeredAddress, setRegisteredAddress] = useState("test");
  const [principalAddress, setPrincipalAddress] = useState("");
  const [stockExchangeText, setStockExchangeText] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");

  const [bankdata, setBankdata] = useState([]);
  const [accountCount, setAccountCount] = useState(7);
  const [photoIdText, setPhotoIdText] = useState("John");
  const [nonphotoIdText, setNonPhotoIdText] = useState("John");
  const [nonphotoId, setNonPhotoId] = useState(null);
  const [photoId, setphotoId] = useState(1);
  const [filePhotographicId, setFilePhotographicId] = useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [expiryDate, setExpiryDate] = useState("02/12/2026");
  const [expiryDateSecond, setExpiryDateSecond] = useState("");
  const [photoIdFirst, setphotoIdFirst] = useState(1);
  const [photoIdFirstText, setphotoIdFirstText] = useState("");
  const [photoIdSecondText, setphotoIdSecondText] = useState("");
  const [ticketLink, setTicketLink] = useState("");
  const [filePublicDocument, setFilePublicDocument] = useState(null);
  const [fileExtractDocument, setFileExtractDocument] = useState(null);
  const [fileDisclosure, setFileDisclosure] = useState(null);
  const [fileCompanyRegistration, setFileCompanyRegistration] = useState(null);
  const [trusteeResponse, setTrusteeResponse] = useState(null);

  const [photoIdSecond, setphotoIdSecond] = useState(2);
  const [fileTicket, setFileTicket] = useState(null);
  const [filePhotographicIdFirst, setfilePhotographicIdFirst] = useState(null);
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState(null);
  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState(null);
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState(null);
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] =
    useState(null);
  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState(null);
  const [fileNonPhotographicId, setfileNonPhotographicId] = useState(null);
  const [personalDataId, setPersonalDataId] = useState(1);
  const [personalDataIdText, setPersonalDataIdText] = useState("");
  const [fileCV, setFileCV] = useState(null);
  const [webLink, setWebLink] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [customDate, setCustomDate] = useState("");

  const [minimumInvestment, setminimumInvestment] = useState(0);
  const [limitDurationLabel, setLimitDurationLabel] = useState("Per Day");
  const [signatoryTypeLabel, setSignatoryTypeLabel] = useState(1);
  const [signatoryType, setSignatoryType] = useState(1);
  const [members, setMembers] = useState([]);
  const [collapsedLayers, setCollapsedLayers] = useState({}); // { layerName: true/false }
  const [layers, setLayers] = useState([]);
  const [shareholders, setShareholders] = useState([]);
  const [layerData, setLayerData] = useState({});
  const [fileAdviceStatement, setFileAdviceStatement] = useState(null);
  const [fileActivityEvidence, setFileActivityEvidence] = useState(null);
  const [abnStatus, setAbnStatus] = useState("");
  const [ifApplicable, setIfApplicable] = useState("no");
  const [fileFinancialService, setFileFinancialService] = useState(null);
  const [jurisdiction, setJurisdiction] = useState("");
  const [stockexchangeLocation, setStockexchangeLocation] = useState("");
  const [fileForeignRegistration, setFileForeignRegistration] = useState(null);
  const [fileLicense, setFileLicense] = useState(null);
  const [hasLicense, setHasLicense] = useState("no");
  const [licenseNumber, setLicenseNumber] = useState("");
  const [fileSelfManagedExtract, setFileSelfManagedExtract] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileAmlProgram, setFileAmlProgram] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [hasAml, setHasAml] = useState({
    verification_id: null,
    value: false,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileProspectusDocument, setFileProspectusDocument] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileRegisteredSubject, setFileRegisteredSubject] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileGovFund, setFileGovFund] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileTrustDeed, setFileTrustDeed] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileScheme, setFileScheme] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };
  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const handleCollapseAll = () => {
    const newState = {};
    layers.forEach((l) => {
      newState[l.id] = true; // collapsed
    });
    setCollapsedLayers(newState);
  };

  const handleExpandAll = () => {
    const newState = {};
    layers.forEach((l) => {
      newState[l.id] = false; // expanded
    });
    setCollapsedLayers(newState);
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const submitApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/onboarding/stakeholder/trust/review-submit/submit/${shareholderId}`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleSubmit = async () => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI();
      if (response.status == 200) {
        toastMessage = { message: response.message, type: "success" };
        const responseStatus = await GetAPIcalls(
          `/v1/onboarding/stakeholder/status/${shareholderId}`,
        );
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatusShareholder(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/v1/onboarding/stakeholder/rejected-fields/${shareholderId}`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
      setIsConfirmSubmit(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const mapIncomeAssetsToMembers = (apiData = []) => {
    return apiData.map((item) => ({
      revenueType: {
        value: item?.revenue_type?.id ?? null,
        label: item?.revenue_type?.name ?? "",
      },

      countryType: {
        value: item?.country?.id ?? null,
        label: item?.country?.name ?? "",
      },

      assetValue: {
        raw: item?.value,
        display: item?.value
          ? new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(Number(item.value))
          : "",
      },
    }));
  };

  const mapApiLayersToUiLayers = (apiLayers = []) => {
    return apiLayers.map((layer) => {
      const hasTabs = Array.isArray(layer.tabs);

      // Case 1: entities-based layer (NO tabs)
      if (!hasTabs) {
        return {
          id: layer.layer_number, // ✅ stable key
          layerName: `Layer ${layer.layer_number}`,
          hasTabs: false,
          groups: [
            {
              parent: null,
              shareholders: (layer.entities || []).map((e) => ({
                id: e.id,
                name: e.name,
                type: e.stakeholder_type?.id || "",
                typeText: e.stakeholder_type?.name || "",
                shares: e.percentage_ownership,
                email: e.email,
                userId: e.beneficiary_user_id,
                errors: {},
              })),
            },
          ],
        };
      }

      // Case 2: tabs-based layer
      return {
        id: layer.layer_number, // ✅ stable key
        layerName: `Layer ${layer.layer_number}`,
        hasTabs: true,
        groups: layer.tabs.map((tab) => ({
          parent: {
            id: tab.parent_id,
            name: tab.parent_name,
          },
          shareholders: (tab.group?.beneficiaries || []).map((s) => ({
            id: s.id,
            name: s.name,
            type: s.stakeholder_type?.id || "",
            typeText: s.stakeholder_type?.name || "",
            shares: s.percentage_ownership,
            email: s.email,
            userId: s.beneficiary_user_id,
            errors: {},
          })),
        })),
      };
    });
  };
  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/stakeholder/trust/review-submit/preview/${shareholderId}`,
      );

      if (response.status == 200) {
        // trust information
        setAccountTypeLabel(response.data.trust_information.trust_type.name);
        setCountryType(
          response.data.trust_information.country_of_established.name,
        );
        setCountryId(response.data.trust_information.country_of_established.id);
        setCompanycategoryId(response.data.trust_information.trust_type.id);

        setFullName(response.data.trust_information.trust_full_name);
        setFullSettlorName(response.data.trust_information.settlor_full_name);
        setFormerNames(response.data.trust_information.all_trading_names);
        setTrustType(response.data.trust_information.trust_type_category.name);
        setRegisteredAddress(
          response.data.trust_information.registered_address.google_address,
        );
        setRegistrationNumber(
          response.data.trust_information.registration_number,
        );
        setSource(response.data.trust_information.source_of_funds);
        setPurpose(response.data.trust_information.purpose_of_account);
        setBusinessNature(response.data.trust_information.business_nature.name);
        if (response.data.trust_information.country_of_established.id) {
          setAbn(response.data.trust_information.abn);
          setAbnStatus(response.data.trust_information.abn_status);
        }
        setActivity(response.data.trust_information.business_activities);
        if (response.data.trust_information.business_activities.id == 6) {
          setOtherActivity(
            response.data.trust_information.business_activities_description,
          );
        }
        setToCurrency(
          response.data.trust_information.default_investment_currency.name,
        );
        // setTransactionLevel(response.)
        setInvestmentAmount(
          response.data.trust_information.expected_investment_amount,
        );
        if (response.data.trust_information.income_assets?.length) {
          const mappedMembers = mapIncomeAssetsToMembers(
            response.data.trust_information.income_assets,
          );
          setAssets(mappedMembers);
        }
        //Trustees
        setTrusteeResponse(response.data.trustees_beneficiaries);
        // Beneficiaries
        const uiLayers = mapApiLayersToUiLayers(
          response.data.trustees_beneficiaries.beneficiaries.layers,
        );
        setLayers(uiLayers);
        dispatch(clearApplicationTypeShareHolder());

        // upload docs
        setFileScheme(
          response.data.proof_documents?.managed_investment_scheme_memorandum,
        );
        setFileRegisteredSubject(
          response.data.proof_documents?.regulatory_oversight_document,
        );
        setFileGovFund(
          response.data.proof_documents?.government_superannuation_document,
        );
        setFileTrustDeed(response.data.proof_documents?.trust_deed_document);
        setFileExtractDocument(
          response.data.proof_documents?.regulator_database_search_document,
        );
        setFileProspectusDocument(
          response.data.proof_documents?.prospectus_document,
        );
        setFileAccountantCertificate(
          response.data.proof_documents?.accountant_certificate_document,
        );
        setFileSelfManagedExtract(
          response.data.proof_documents?.smsf_lookup_extract_document,
        );
        setHasAml(
          response.data.proof_documents?.satisfies_geographic_link_test,
        );
        setFileProof(response.data.proof_documents?.audit_report_document);
        setFileAmlProgram(response.data.proof_documents?.aml_program_document);

        setIsDataAvailable(true);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setIsDataAvailable(true);
    } finally {
    }
  };

  useEffect(() => {
    getDetails();
  }, []);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[3].status == "IN_REVIEW" ||
            stepStatus[3].status == "COMPLETED") && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                Your application is{" "}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{" "}
              </span>
            </div>
          )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2 mb-2">
              <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
              <h1 className="text-xl font-medium">
                Review And submit your information
              </h1>
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img
                  src="/briefcase.svg"
                  alt="User Avatar"
                  className="h-6 w-6"
                />
                <h1 className="text-xl font-medium">Trust Information</h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(1);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>

            <div className="bg-white pb-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                <div className="flex flex-col px-4 pt-4">
                  <LabelValue
                    id="trustType"
                    label="Select the type of trust"
                    value={accountType.label}
                  />
                  <label
                    htmlFor="firstName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Trust Logo
                  </label>
                  <div className="relative flex-shrink-0 mb-4 lg:mb-0 mt-1 mr-6">
                    <img
                      src={preview}
                      alt={`${fullName}`}
                      className="w-20 h-20 rounded-full object-cover"
                    />
                  </div>
                  <LabelValue
                    id="fullName"
                    label="Full Name of the Trust"
                    value={fullName}
                    className="mt-4"
                  />
                  <LabelValue
                    id="fullSettlorName"
                    label="The full name of the settlor of the trust"
                    value={fullSettlorName}
                    className="mt-4"
                  />
                  <LabelValue
                    id="fullSettlorName"
                    label="All business names used by the trust and any other name
                    under which the trust operates"
                    value={formerNames}
                    className="mt-4"
                  />
                </div>
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <LabelValue
                    id="trustCategory"
                    label="Select the Type Trust Category"
                    value={trustType}
                  />
                  <LabelValue
                    id="countryType"
                    label="Country in which the trust was established"
                    value={countryType}
                    className="mt-4"
                  />
                  <LabelValue
                    id="registeredAddress"
                    label="Trust's Registered Address"
                    value={registeredAddress}
                    className="mt-4"
                  />
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                  <LabelValue
                    id="clientNo"
                    label="Client ID"
                    value={clientNo}
                  />
                  <LabelValue
                    id="advisorRefNumber"
                    label="Advisor Ref No"
                    value={refNumber}
                    className="mt-4"
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                <div className="flex flex-col px-4 pt-4">
                  <LabelValue
                    id="registrationNumber"
                    label="Registration Number"
                    value={registrationNumber}
                  />
                  <>
                    <LabelValue
                      id="source"
                      label="Source of the funds including its origin"
                      value={source}
                      className="mt-4"
                    />
                    <LabelValue
                      id="purpose"
                      label="Purpose of Opening Caprock Account"
                      value={purpose}
                      className="mt-4"
                    />
                  </>
                </div>
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <LabelValue
                    id="businessNature"
                    label="Business Nature"
                    value={businessNature}
                  />
                  {countryType == 14 && (
                    <>
                      <FilePreview
                        label="Upload ABN Lookup Extract"
                        file={fileAbn}
                        onClick={handleFileClick}
                      />
                    </>
                  )}
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                  <LabelValue
                    id="businessActivity"
                    label="Nature of the business activities conducted by the trust"
                    value={activity?.name}
                  />
                  {activity?.id == 6 && (
                    <LabelValue
                      id="otherActivity"
                      label="Please mention business activity"
                      value={otherActivity}
                      className="mt-4"
                    />
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                <div className="flex flex-col px-4 pt-4">
                  <LabelValue
                    id="toCurrency"
                    label="Default Investment Currency"
                    value={toCurrency}
                  />
                </div>
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <LabelValue
                    id="transactionLevel"
                    label="Nature and level of the intended transaction behaviour"
                    value={transactionLevel}
                  />
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                  <LabelValue
                    id="businessActivity"
                    label="Expected Investment Amount"
                    value={investmentAmount}
                  />
                </div>
              </div>
              <div className="flex items-center border-b border-colour-custom space-x-2 px-4 mt-4">
                <h1 className="text-xl font-medium mb-2">
                  Income and assets (including location) of the trust
                </h1>
              </div>
              <div className="overflow-x-auto">
                <table className="min-w-[800px] w-full text-sm text-left border rounded overflow-hidden">
                  {/* Table Head */}
                  <thead className="bg-[#F9F9F9] text-labelColour font-semibold">
                    <tr>
                      <th className="p-2 w-[40px]"></th>
                      <th className="p-2">Type of Revenue</th>
                      <th className="p-2">Location</th>
                      <th className="p-2">Value of asset or income</th>
                      <th className="p-2 w-[40px]"></th>
                    </tr>
                  </thead>

                  {/* Table Body */}
                  <tbody>
                    {assets.map((member, idx) => (
                      <tr key={idx} className="border-t bg-white align-top">
                        {/* Index */}
                        <td className="px-4 py-4 font-medium text-gray-600">
                          {(idx + 1).toString().padStart(2, "0")}.
                        </td>
                        <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                          {member.revenueType.label}
                        </td>
                        <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                          {member.countryType.label}
                        </td>
                        <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                          {member.assetValue.display}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="mt-4">
            <TrusteesPanel
              trusteeResponse={trusteeResponse}
              isEdit={false}
              trusteeName={firstName + " " + lastName}
            />
          </div>
          <div className="bg-white mt-4 border rounded-md p-4">
            <div className="bg-white  rounded-md mt-4">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-2 md:space-y-0 px-2">
                <div className="flex items-center space-x-2">
                  <img
                    src="/people.svg"
                    alt="User Avatar"
                    className="h-6 w-6"
                  />
                  <h1 className="text-xl font-medium">
                    Shareholders:
                    <span className="text-xl font-medium text-[#8C8C8C] ml-1">
                      {firstName} {lastName}
                    </span>
                  </h1>
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={handleCollapseAll}
                    className="bg-white text-black text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                  >
                    <img
                      src="/arrow-square-up.svg"
                      alt="Collapse Icon"
                      className="w-4 h-4 flex-shrink-0"
                    />
                    <span className="font-medium">Collapse All</span>
                  </button>
                  <button
                    onClick={handleExpandAll}
                    className="bg-black text-white text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                  >
                    <img
                      src="/arrow-square-down.svg"
                      alt="Collapse Icon"
                      className="w-4 h-4 flex-shrink-0"
                    />
                    <span className="font-medium">Expand All</span>
                  </button>
                </div>
              </div>
              <div className="pt-2">
                {layers.map((layer) => (
                  <ShareholderLayer
                    key={layer.id}
                    layer={layer}
                    collapsed={collapsedLayers[layer.id] ?? false}
                    onToggle={() =>
                      setCollapsedLayers((prev) => ({
                        ...prev,
                        [layer.id]: !prev[layer.id],
                      }))
                    }
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Upload Proof Documents</h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(5);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b pb-2">
              {/* first column */}
              <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                {companycategoryId == 1 && (
                  <>
                    <FilePreview
                      label="A managed investment scheme that is not registered by Regulator in your specific country and that only has wholesale clients and does not make small scale offerings Memorandum"
                      file={fileScheme}
                      onClick={handleFileClick}
                    />
                    <div className="mt-4">
                      <FilePreview
                        label="Registered and subject to the regulatory oversight of a regulator in relation to its activities as a trust"
                        file={fileRegisteredSubject}
                        onClick={handleFileClick}
                      />
                    </div>
                  </>
                )}
                {companycategoryId != 1 && countryId == 14 && (
                  <>
                    <div className="mt-4">
                      <label
                        htmlFor="description"
                        className="mb-1 text-sm text-labelColour"
                      >
                        ABN
                      </label>
                      <span>{abn}</span>
                    </div>
                    <div className="mt-4">
                      <label
                        htmlFor="description"
                        className="mb-1 text-sm text-labelColour"
                      >
                        ABN Status
                      </label>
                      <span>{abnStatus}</span>
                    </div>
                  </>
                )}
                {companycategoryId != 1 && countryId != 14 && (
                  <div className="mt-4">
                    <FilePreview
                      label="Trust Deed"
                      file={fileTrustDeed}
                      onClick={handleFileClick}
                    />
                  </div>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                {companycategoryId == 1 && (
                  <>
                    <div className="">
                      <FilePreview
                        label="A government superannuation fund established by legislation."
                        file={fileGovFund}
                        onClick={handleFileClick}
                      />
                    </div>
                    <div className="mt-4">
                      <FilePreview
                        label="Trust Deed"
                        file={fileTrustDeed}
                        onClick={handleFileClick}
                      />
                    </div>
                  </>
                )}
                {(companycategoryId == 3 ||
                  (companycategoryId == 2 && countryId == 14)) && (
                  <FilePreview
                    label="A managed investment scheme registered by ASIC - Upload Prospectus Document"
                    file={fileProspectusDocument}
                    onClick={handleFileClick}
                  />
                )}

                {companycategoryId == 2 && countryId != 14 && (
                  <FilePreview
                    label="Self-Managed Super Fund Lookup Extract"
                    file={fileSelfManagedExtract}
                    onClick={handleFileClick}
                  />
                )}
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4 pt-4">
                {(companycategoryId == 1 ||
                  (companycategoryId == 2 && countryId != 14)) && (
                  <>
                    <div className="">
                      <FilePreview
                        label="A search of the relevant ASIC, APRA or other regulator database"
                        file={fileExtractDocument}
                        onClick={handleFileClick}
                      />
                    </div>
                    {companycategoryId == 1 && (
                      <div className="mt-4">
                        <FilePreview
                          label="A managed investment scheme registered by ASIC - Upload Prospectus Document"
                          file={fileProspectusDocument}
                          onClick={handleFileClick}
                        />
                      </div>
                    )}
                  </>
                )}
                {companycategoryId == 3 && countryId != 14 && (
                  <>
                    <label
                      htmlFor="investmentType"
                      className="labelColour block whitespace-normal break-words text-sm text-labelColour flex items-center mt-4"
                    >
                      Do you satisfy one of the geographical link tests in ss
                      6(6) of the AML/CTF Act or that its name and enrolment
                      details are entered on the Reporting Entities Roll; and
                      that it has carried out all applicable KYC and ongoing
                      customer due diligence requirements in accordance with
                      Chapter 15 of the AML/CTF Rules in relation to its
                      underlying customers, prior to, or at the time of becoming
                      a customer of Caprock.
                    </label>
                    <div className="flex items-center gap-4 opacity-50 ">
                      <label className="flex items-center text-sm text-black">
                        <input
                          type="radio"
                          name="signatory"
                          value={true}
                          checked={hasAml === true}
                          disabled={true}
                          className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                        />
                        <span className="ml-2">Yes</span>
                      </label>
                      <label className="flex items-center text-sm text-black">
                        <input
                          type="radio"
                          name="signatory"
                          value={false}
                          checked={hasAml === false}
                          disabled={false}
                          className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                        />
                        <span className="ml-2">No</span>
                      </label>
                    </div>
                    {hasAml.value === true && (
                      <>
                        <div className="mt-4">
                          <FilePreview
                            label="Audit Report (Most Recent)"
                            file={fileProof}
                            onClick={handleFileClick}
                          />
                        </div>
                        <div className="mt-4">
                          <FilePreview
                            label="AML Program"
                            file={fileAmlProgram}
                            onClick={handleFileClick}
                          />
                        </div>
                      </>
                    )}
                  </>
                )}
                {countryId == 14 && (
                  <div className={`${companycategoryId == 3 ? "" : "mt-4"}`}>
                    <FilePreview
                      label="Accountant Certificate"
                      file={fileAccountantCertificate}
                      onClick={handleFileClick}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {stepStatus[3] &&
        stepStatus[3].status !== "COMPLETED" &&
        stepStatus[3].status !== "APPROVED" &&
        stepStatus[3].status !== "IN_REVIEW" && (
          <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
            <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setLoading(true);
                  handleSubmit();
                }}
                className="flex bg-white w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-black font-medium py-2 px-4 rounded-full text-sm"
              >
                <span>Submit</span>
              </button>
            </div>
          </footer>
        )}{" "}
      {isConfirmSubmit && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <button class="absolute top-3 right-3 text-black text-xl font-bold">
              &times;
            </button>

            <div class="flex justify-center items-center mb-4">
              <div class="flex items-center justify-center">
                <img
                  src="/tick-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 class="text-lg font-medium mb-2">Hi John!</h2>
            <h2 class="text-md font-medium mb-2">
              Individual Application Form has been Submitted Successfully{" "}
            </h2>
            <p class="text-sm text-black mb-4">
              Caprock team will evaluate your application and get back to you
              shortly.
            </p>
            <p class="text-sm text-black mb-4">Thank You. </p>
          </div>
        </div>
      )}
    </div>
  );
};
const ShareholderLayer = ({ layer, collapsed, onToggle }) => {
  const { layerName, groups, hasTabs } = layer;
  const isOpen = !collapsed;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState(0);
  const rowsToRender = hasTabs
    ? groups[activeTab]?.shareholders || []
    : groups[0]?.shareholders || [];
  const calculateSharesCounter = (list) =>
    list.reduce((acc, s) => acc + Number(s.shares || 0), 0).toFixed(2);

  useEffect(() => {
    setActiveTab(0);
  }, [groups]);

  const currentRows = groups[activeTab]?.shareholders || [];

  return (
    <div className="border rounded-2xl shadow-sm bg-white mb-6">
      {/* Header */}
      <div
        onClick={onToggle}
        className="bg-[#464646] text-white px-4 py-2 rounded-t-2xl flex justify-between items-center cursor-pointer"
      >
        <h2 className="text-sm font-medium">{layerName}</h2>
        <span className="text-lg">{isOpen ? "−" : "+"}</span>
      </div>

      {isOpen && (
        <>
          {/* Tabs ONLY when groups > 1 */}
          {hasTabs && (
            <div className="flex border-b">
              {groups.map((g, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveTab(idx)}
                  className={`px-4 py-2 text-sm font-medium ${
                    activeTab === idx
                      ? "bg-black text-white"
                      : "bg-gray-100 text-gray-600"
                  }`}
                >
                  {g.parent?.name}
                </button>
              ))}
            </div>
          )}

          {/* Table */}
          <div className="p-4 border rounded-b-lg">
            <div className="overflow-x-auto">
              <table className="w-full text-sm  text-[#8C8C8C]">
                <thead>
                  <tr className="border">
                    <th className="p-2"></th>
                    <th className="p-2 text-left font-medium">
                      Shareholder Name
                    </th>
                    <th className="p-2 text-left font-medium">Type</th>
                    <th className="p-2 text-left font-medium">Shares</th>
                    <th className="p-2 text-left font-medium">Email</th>
                    <th className="p-2 text-left font-medium">
                      User Registration
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rowsToRender.map((s, idx) => (
                    <tr key={s.id} className="border-t font-medium text-black">
                      <td className="p-2 text-[#8C8C8C]">
                        {String(idx + 1).padStart(2, "0")}.
                      </td>
                      <td className="p-2">{s.name}</td>
                      <td className="p-2">{s.typeText}</td>
                      <td className="p-2">{s.shares}</td>
                      <td className="p-2">{s.email}</td>
                      <td className="p-2">
                        {s.shares >= 25 ? (
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              let redirectState = {
                                path: `/onboarding-shareholder/${s.userId}/${s.type}/shareholder/${false}`,
                                state: {
                                  from: location.pathname,
                                },
                              };
                              sessionStorage.setItem(
                                "redirectAfterLogin",
                                JSON.stringify(redirectState),
                              );
                              navigate(
                                `/onboarding-shareholder/${s.userId}/${s.type}/shareholder/${false}`,
                                {
                                  state: {
                                    from: location.pathname,
                                  },
                                },
                              );
                            }}
                            className="px-3 py-1 rounded-lg  border bg-[#D3D3D3] text-[#9C9C9C] font-medium"
                          >
                            View Application
                          </button>
                        ) : (
                          <span className="text-gray-400">—</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default ReviewSubmitTrust;
